import React, { useContext } from 'react';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

export const VatIdField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return <FullInfoField label="vatIdLabel" value={restaurantForFullInfo?.vatId} />;
};
